import React from 'react';
import DoubleArrowLeft from "../../icons/DoubleArrowLeft";
import DoubleArrowRight from "../../icons/DoubleArrowRight";
import colors from "../../utils/colors";
import clsx from 'clsx';
import { createStyles } from "./styles";











var FilterArrowButton = function FilterArrowButton(_ref)




{var direction = _ref.direction,button = _ref.button,onActionClick = _ref.onActionClick,_ref$buttonWrapperSty = _ref.buttonWrapperStyle,buttonWrapperStyle = _ref$buttonWrapperSty === void 0 ? '' : _ref$buttonWrapperSty;
  var classes = createStyles();

  var keyPressHandler = function keyPressHandler(e) {
    if (e.keyCode === 13) {
      onActionClick();
    }
  };
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.buttonWrapper, buttonWrapperStyle) },
    direction === 'left' ? /*#__PURE__*/
    React.createElement("div", {
      className: classes.openButtonWrapper,
      role: "button",
      onClick: onActionClick,
      tabIndex: 0,
      onKeyDown: keyPressHandler }, /*#__PURE__*/

    React.createElement(DoubleArrowLeft, { width: "2rem", color: colors.blue[600], className: classes.icon }),
    button) : /*#__PURE__*/


    React.createElement("div", {
      className: classes.closeButtonWrapper,
      role: "button",
      onClick: onActionClick,
      tabIndex: 0,
      onKeyDown: keyPressHandler }, /*#__PURE__*/

    React.createElement(DoubleArrowRight, { width: "2rem", color: colors.blue[600], className: classes.icon }),
    button)));




};

export default FilterArrowButton;
//# sourceMappingURL=index.js.map